/**
 * 弹层挂载点：优先 PC 手机壳 `#h5-shell`，使 fixed 相对壳宽；
 * 无壳（真机）时回退 `document.body`。
 */
export function getOverlayMount(): HTMLElement {
  if (typeof document === 'undefined') {
    throw new Error('getOverlayMount requires document');
  }
  return document.getElementById('h5-shell') || document.body;
}
